// ===== rules/rule-6305-multi-cath.ts ======================================
import { BaseRule } from '../rule-base';
import { AdjustedLine, ModifierContext } from '../modifier-models';

/**
 * 6305 – multiple catheterisations:
 * For every *catheterisation tariff* after the first, subtract 20 radiology units.
 * Recognised tariff codes: 3557, 3559, 3560, 3562.
 */
const CATH_CODES = new Set(['3557', '3559', '3560', '3562']);

export class RuleMultiCath6305 extends BaseRule {
    name = '6305 multi-cath -20u each extra';

    run(line: AdjustedLine, ctx: ModifierContext, autoApply: boolean): void {
        if (line.isModifier || line.isConsult || !CATH_CODES.has(line.code)) return;

        // Since we need to know if this is the first catheterisation,
        // we'll need to rely on the apply method for this rule
        if (autoApply) {
            line.trace.push('6305: Requires full context for calculation');
        } else {
            line.suggestions = line.suggestions || [];
            line.suggestions.push({
                ruleCode: '6305',
                message: 'Multiple catheterisation calculation requires full context',
                kind: 'subtraction'
            });
        }
    }

    apply(lines: AdjustedLine[], ctx: ModifierContext): AdjustedLine[] {
        // keep original order
        const caths = lines.filter(l => !l.isModifier && !l.isConsult && CATH_CODES.has(l.code));
        caths.slice(1).forEach(l => {
            const minus = Math.min(20, l.adjustedUnits);
            l.adjustedUnits -= minus;
            l.trace.push('6305 -20u');
        });
        return lines;
    }
}
